import React from "react";
import { Fragment } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Icon from "@material-ui/core/Icon";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import Card from "components/Card/Card.jsx";
import ClearButton from "components/CustomButtons/Button";
// import Select from "react-select";
// import InputLabel from "@material-ui/core/InputLabel";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "../../../config/axios";
// import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from "draft-js";
import { connect } from "react-redux";
import ReactTable from "react-table";
import toastr from "toastr";
// import _ from "lodash";
import loaderIcon from "../../../assets/img/loader.gif";
import { getEventBookings$ } from "../../../redux/actions/event";
import Tooltip from "@material-ui/core/Tooltip";
// import ReactQuill from "react-quill";
import DeleteModel from "components/Common/FevoModels/DeleteModel";
import "react-quill/dist/quill.snow.css";
import IconButton from "@material-ui/core/IconButton";
import green from "@material-ui/core/colors/green";
import { hist } from "../../..";
import Select from "react-select";
import ViewDetails from "./ViewDetails";
import { Button, FormControl } from "@material-ui/core";
import { PortraitSharp } from "@material-ui/icons";
toastr.options = {
  closeButton: true,
};

const moment = extendMoment(originalMoment);

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["image"],
    //['link', 'image', 'video'],
    //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    ["blockquote", "code-block"],
    //[{ 'direction': 'rtl' }],                         // text direction
    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    ["clean"], // remove formatting button
  ],
};

const userOptions = [
  { value: "normal", label: "Normal" },
  { value: "student", label: "Student" },
  { value: "government", label: "SG Government" },
];

const ticketOptions = [
  { value: "earlybird", label: "Early Bird Price" },
  { value: "normal", label: "Normal Price" },
  { value: "student", label: "Student Price" },
  { value: "group", label: "Group booking Price" },
  // { value: 'coupan', label: 'Complimentary(Booking done via coupon code)' },
];

const fiter_style = {
  display: "flex",
  alignItems: 'baseline'
};

function TabContainer({ children, dir }) {
  return (
    <Typography
      component="div"
      dir={dir}
      style={{
        padding: 8 * 3,
      }}
    >
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
const formStyle = {
  minWidth: 300,
  margin: "0 1.2rem 1.2rem 0",
};

class EventDetail extends React.Component {
  state = {
    activeTab: 0,
    amount: null,
    allowedBannerCount: 10,
    appovedUser: [],

    editorState: EditorState.createEmpty(),
    loading: false,
    topic: null,
    start_date: null,
    duration: null,
    VIPseats: null,
    normalSeats: null,
    waitingSeats: null,
    unapprovedSeats: null,
    agenda: null,
    webinar_image: null,
    webinarType: null,
    id:
      this.props.location.state &&
      this.props.location.state.webinar &&
      this.props.location.state.webinar.id,
    loader: false,
    event_name: null,
    normalUserBooking: null,
    VIPBooking: null,
    waitingBooking: null,
    waitingUser : [],
    unapprovedBooking: null,
    seatsToBeChangedValue: null,
    seatsToBeChanged: null,
    showAcceptModal: false,
    cancelModalreject: false,
    popText: null,
    created_at: null,
    close_registration: null,
    status: null,
    waiting_status_check: false,
    showCloseModal: false,
    closePopText: null,
    textField: null,
    group_booking_price: null,
    student_price: null,
    normal_price: null,
    early_bird_price: null,
    expiry_date: null,
    webinar_type: null,
    eye_visible: false,
    registrant_type: null,
    payload: undefined,
    selected_user_type: null,
    selected_ticket_type: null,
    ticket_type: null,
    booking_id: null,
    showPaymentModel: false,
    paymentTitle: "",
    booking_status: "",
    showVerificationModel: false,
    verificationTitle: "",
    remaining_vip_seats: null,
    total_seats: null,
    remaining_waiting_seats: null,
    ticketTypeList: [
      { value: "Select Ticket Type", label: "Select Ticket Type" },
      { value: "NORMAL", label: "NORMAL" },
      { value: "EARLY_BIRD", label: "EARLY_BIRD" },
      { value: "STUDENT", label: "STUDENT" },
      { value: "GROUP", label: "GROUP" },
      { value: "COUPON", label: "COUPON" },
    ],
    userTypeList: [
      { value: "Select User type", label: "Select User type" },
      { value: "NORMAL", label: "NORMAL" },
      { value: "VIP", label: "VIP" },
      { value: "GOVERNMENT", label: "GOVERNMENT" },
    ],
    ticket_type: "",
    user_type: "",
    user_type_manageRequest: "",
    ticket_type_manageRequest: "",
    user_type_normal: "",
    ticket_type_normal: "",
  };

  getNormalBookingData = () => {
    const { selected_ticket_type, selected_user_type, id } = this.state;
    const val1 =
      selected_ticket_type && selected_ticket_type.value
        ? selected_ticket_type.value
        : "APPROVED,PENDING";
    const val2 =
      selected_user_type && selected_user_type.value
        ? selected_user_type.value
        : "";

    axios
      .get(
        `zoom/ViewAllWebinarRegistrationsListTypes?webinar_id=${id}&registrant_type=NORMAL,GOVERNMENT&user_type=${val2}&ticket_type=${val1}`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          this.setState({
            normalUserBooking: res.data.data,
            appovedUser : res.data.data,
          });
        }
      });
  };

  getVIPBookingData = (id) => {
    axios
      .get(
        `zoom/ViewAllWebinarRegistrationsListTypes?webinar_id=${id}&registrant_type=VIP&user_type=&ticket_type=`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          this.setState({
            VIPBooking: res.data.data,
          });
        }
      });
  };

  getWaitingBookingData = () => {
    const { selected_ticket_type, selected_user_type, id } = this.state;

    axios
      .get(
        `zoom/ViewAllWebinarRegistrationsListTypes?webinar_id=${id}&registrant_type=NORMAL,GOVERNMENT&user_type=&ticket_type=WAITING,REJECTED`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          this.setState({
            waitingBooking: res.data.data,
            waitingUser : res.data.data
          });
        }
      });
  };

  getAllWebinarSeats = async (webinarId) => {
    console.log(webinarId,'inside getAllSeatsData')
   await axios
    .get(
      `zoom/viewWebinarByWebinarId?webinar_id=${webinarId}`
    )
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        const { data } = res;
        this.setState({
          ...this.state,
          VIPseats: data && data.data && data.data.vip_seats,
          normalSeats: data && data.data && data.data.normal_seats,
          waitingSeats: data && data.data && data.data.waiting_seats,  
          remaining_vip_seats: data && data.data && data.data.remaining_vip_seats,
          remaining_normal_seats: data && data.data && data.data.remaining_normal_seats,
          remaining_waiting_seats: data && data.data && data.data.remaining_waiting_seats,
          total_seats:data && data.data && data.data.total_seats,
        });
        console.log(data,'responseData in getAllSeatsData')

        }
    });
  }

  componentDidMount = () => {
    if (this.props.location.state) {
      const { webinar } = this.props.location.state;
      // debugger;
      let {
        id,
        // host_email,
        agenda,
        amount,
        created_at,
        duration,
        topic,
        vip_seats,
        waiting_seats,
        unapproved_seats,
        type,
        normal_seats,
        status,
        start_time,
        webinar_images,
        close_registration,
        group_booking_price,
        student_price,
        normal_price,
        early_bird_price,
        expiry_date,
        webinar_type,
        uuid,
        // remaining_vip_seats,
        // remaining_normal_seats,
        // total_seats,
        // remaining_waiting_seats,
      } = webinar;
      if (close_registration) {
        this.setState({
          textField: "Start Registration",
        });
      } else {
        this.setState({
          textField: "Pause Registration",
        });
      }
      let eventDate = moment(start_time);
      let currentDate = moment(new Date().toISOString());
      let result = eventDate.diff(currentDate, "days");
      // console.log("result", result);
      var resultHours = eventDate.diff(currentDate, "hours", true);
      if (resultHours < 72) {
        this.setState({
          waiting_status_check: true,
        });
      }

      this.getNormalBookingData();
      this.getVIPBookingData(id);
      this.getWaitingBookingData();
      this.getAllWebinarSeats(id)

      // axios.get(`zoom/ViewAllWebinarRegistrationsListTypes?webinar_id=${id}`).then(res => {
      //   if (res.status === 200 || res.status === 201) {

      //     this.setState({
      //       normalUserBooking: res.data.data.Normal,
      //       VIPBooking: res.data.data.VIP,
      //       waitingBooking: res.data.data.Waiting,
      //       unapprovedBooking: res.data.data.UnApproved,
      //     })
      //   }

      // });

      let event_name;

      if (type === 5) {
        event_name = "One time";
      } else {
        event_name = "Recurring";
      }
      this.setState({
        topic,
        start_date: moment(start_time).format("DD MMM YYYY, h:mm a"),
        duration,
        agenda,
        amount,
        // VIPseats: vip_seats,
        // normalSeats: normal_seats,
        // waitingSeats: waiting_seats,
        unapprovedSeats: unapproved_seats,
        webinar_image:
          webinar_images && webinar_images.length > 0 && webinar_images[0].path,
        webinarType: type,
        id,
        event_name,
        created_at: moment(created_at).format("DD MMM YYYY, h:mm a"),
        close_registration,
        status,
        group_booking_price,
        student_price,
        normal_price,
        early_bird_price,
        expiry_date: moment(expiry_date).format("DD MMM YYYY, h:mm a"),
        webinar_type,
        // remaining_vip_seats,
        // remaining_normal_seats,
        // total_seats,
        // remaining_waiting_seats,
      });
    }
  };

  updateBookingStatus = () => {
    const { booking_id, booking_status } = this.state;
    const { webinar } = this.props.location.state;
    let body = {
      ticket_status: "approved",
    };
    axios
      .put(`zoom/updateTicketStatus/${booking_id}/${booking_status}`)
      .then((res) => {
        if (
          (res && res.data && res.data.status === 200) ||
          res.data.status === 200
        ) {
          toastr.success(`Ticket has been ${booking_status} Successfully!`);
          setTimeout(() => {
            window.location.reload()
            // this.props.history.push("/admin/managewebinar/webinardetail", {
            //   redirected_webinar: true,
            //   webinar,
            //   redirected_webinar_id: webinar.id,
            // });
          }, 1000);
        } else {
          toastr.error(toastr.error(res && res.data.message));
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((err) => {
        toastr.error(err);
      });
  };

  updatePaymentStatus = () => {
    const { booking_id, ticket_type, amount } = this.state;
    let cashier_id = localStorage.getItem("id");
    let type =
      this.props.location.state &&
      this.props.location.state.webinar &&
      this.props.location.state.webinar.status == "REFUNDED"
        ? "refunded"
        : "received";

    let webinar =
      this.props.location.state &&
      this.props.location.state.webinar &&
      this.props.location.state.webinar;

    axios
      .put(
        `zoom/updatePaymentStatus?booking_id=${booking_id}&received_amount=${amount}&cashier_id=${cashier_id}&payment_type=${type}`
      )
      .then((res) => {
        if (
          (res && res.data && res.data.status === 200) ||
          res.data.status == 201
        ) {
          toastr.success("Payment Status has been Updated successfully!");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          toastr.error(toastr.error(res && res.data.message));
        }
      })
      .catch((err) => {
        if (err.response) {
          toastr.error(err.response.data.message);
        }
      });
  };

  getWaitingBookingColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });

    let column = [
      {
        width: 120,
        Header: "User Type",
        accessor: "user_type",
        Cell: (props) => {
          return (
            <span>
              {props.original.user_type == "NORMAL"
                ? "Normal"
                : props.original.user_type == "STUDENT"
                ? "Student"
                : props.original.user_type == "GOVERNMENT"
                ? "Government"
                : props.original.user_type}
            </span>
          );
        },
      },
      {
        width: 150,
        Header: "Ticket Type",
        accessor: "ticket_type",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              <span>
                {props.original.ticket_type == "NORMAL"
                  ? "Normal"
                  : props.original.ticket_type == "STUDENT"
                  ? "Student"
                  : props.original.ticket_type == "EARLY_BIRD"
                  ? "Early bird"
                  : props.original.ticket_type == "GROUP"
                  ? "Group"
                  : props.original.ticket_type == "VIP"
                  ? "Vip"
                  : props.original.ticket_type}{" "}
              </span>
            </div>
          );
        },
      },
      {
        width: 150,
        Header: "Name",
        Cell: ({ original }) => {
          const { first_name, last_name } = original;
          const fullName =
            first_name && last_name
              ? `${first_name} ${last_name}`
              : first_name
              ? first_name
              : "N/A";
          const name = first_name === last_name ? first_name : fullName;

          return (
            <span>{first_name === last_name ? first_name : fullName}</span>
          );
        },
      },
      {
        width: 250,
        Header: "Organization Id",
        accessor: "org",
      },
      {
        width: 150,
        Header: "Booking Id",
        accessor: "main_booking_id",
      },
      {
        width: 220,
        Header: "Booking Date and Time",
        Cell: (props) => {
          return (
            <span>
              {" "}
              {props.original &&
                moment(props.original.created_date).format(
                  "DD MMM YYYY, h:mm a"
                )}
            </span>
          ); //"DD MMM YYYY, h:mm a"
        },
      },
      {
        width: 170,
        Header: "Booking Status",
        accessor: "booking_status",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              {" "}
              <span>
                {props.original.booking_status == "WAITING"
                  ? "Waiting"
                  : props.original.booking_status == "CONFIRMED"
                  ? "Confirmed"
                  : props.original.booking_status}
              </span>
            </div>
          );
        },
      },
      {
        width: 170,
        Header: "Payment Status",
        accessor: "payment_status",
        Cell: (props) => {
          return (
            <div>
              <span>
                {props.original.payment_status == "PENDING"
                  ? "Pending"
                  : props.original.payment_status == "APPROVED"
                  ? "Approved"
                  : props.original.payment_status == "SUCCESSFUL"
                  ? "Paid"
                  : props.original.payment_status}
              </span>
            </div>
          );
        },
      },
      {
        width: 170,
        Header: "Payment Mode",
        accessor: "payment_mode",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              {" "}
              <span>
                {props &&
                props.original &&
                props.original.payment_mode == "COUPON"
                  ? "Coupon"
                  : props.original.payment_mode == "offline"
                  ? "Offline"
                  : props.original.payment_mode == "CC" ||
                    props.original.payment_mode == "online"
                  ? "Online"
                  : props.original.payment_mode}
              </span>
            </div>
          );
        },
      },
      {
        width: 200,
        Header: "Registration Status",
        accessor: "ticket_status",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "21%" }}>
              <span>
                {props.original.ticket_status == "APPROVED"
                  ? "Approved"
                  : props.original.ticket_status == "PENDING"
                  ? "Pending"
                  : props.original.ticket_status == "WAITING"
                  ? "Waiting"
                  : props.original.ticket_status}
              </span>
            </div>
          );
        },
      },

      {
        minWidth: 250,
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center", width: "150px" },
        Cell: (webinar, props) => {
          return (
            <div>
              {webinar.original.action != "cancel" ? (
                <div
                  className={
                    this.state && this.state.waiting_status_check
                      ? "actions-center disable"
                      : "actions-center"
                  }
                >
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    className={classes.button}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({
                        seatsToBeChanged: webinar.original,
                        seatsToBeChangedValue: true,
                        showAcceptModal: true,
                        popText: "Do you want to approve this seat?",
                      });
                    }}
                  >
                    Accept
                  </Button>
                  <Button
                    color="primary"
                    variant="outlined"
                    size="small"
                    className={classes.button}
                    style={{ marginLeft: "6%", marginRight: "10px" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({
                        seatsToBeChanged: webinar.original,
                        seatsToBeChangedValue: false,
                        showAcceptModal: true,
                        popText: "Do you want to cancel this seat?",
                      });
                    }}
                  >
                    Reject
                  </Button>

                  {webinar.original.ticket_type == "STUDENT" &&
                    (webinar.original.payment_mode == "offline" ||
                      webinar.original.payment_mode == "online") && (
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        className={classes.button}
                        onClick={(e) => {
                          // console.log(event,'e in onclick')
                          e.stopPropagation();
                          // console.log("87878788")
                          this.props.history.push(
                            "/admin/managewebinar/registrationDetails",
                            {
                              webinar: webinar.original,
                            }
                          );
                        }}
                      >
                        View
                      </Button>
                    )}
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  {/* <span>{webinar.original.action=="CANCELED" ? "Cancelled":""}</span> */}
                  <span>
                    {webinar.original.booking_status == "CANCELED" ? (
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          // console.log("87878788")
                          this.props.history.push(
                            "/admin/managewebinar/registrationDetails",
                            {
                              webinar: webinar.original,
                            }
                          );
                        }}
                      >
                        View
                      </Button>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              )}
            </div>
          );
        },
      },
    ];
    return column;
  };

  getUnApprovedBookingColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        Header: "agenda",
        accessor: "agenda",
      },
      {
        Header: "booking_status",
        accessor: "booking_status",
      },
      {
        Header: "payment_mode No",
        accessor: "payment_mode",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "uuid id",
        accessor: "uuid",
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (webinar) => {
          return (
            <div className={"actions-center"}>
              <Button
                color="primary"
                variant="contained"
                className={classes.button}
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.history.push(
                    `/admin/managewebinar/bookingdetails`,
                    {
                      webinar: webinar.original,
                    }
                  );
                }}
              >
                View
              </Button>
            </div>
          );
        },
      },
    ];
    return column;
  };

  getVIPBookingColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        width: 200,
        Header: <span style={{ textAlign: "left" }}>User Type</span>,
        accessor: "user_type",
        Cell: (props) => {
          return (
            <span>
              {props.original.user_type == "NORMAL"
                ? "Normal"
                : props.original.user_type == "STUDENT"
                ? "Student"
                : props.original.user_type == "GOVERNMENT"
                ? "Government"
                : props.original.user_type == "VIP"
                ? "Vip"
                : props.original.user_type}
            </span>
          );
        },
      },
      {
        width: 270,
        Header: "Name",
        Cell: ({ original }) => {
          const { first_name, last_name } = original;
          const fullName =
            first_name && last_name
              ? `${first_name} ${last_name}`
              : first_name
              ? first_name
              : "N/A";
          const name =
            first_name === last_name
              ? first_name
              : `${first_name} ${last_name}`;
          return <span>{name}</span>;
        },
      },
      {
        width: 250,
        Header: "Organization Id",
        accessor: "org",
      },
      {
        width: 200,
        Header: "Booking Id",
        accessor: "main_booking_id",
      },
      {
        width: 220,
        Header: "Booking Date and Time",
        Cell: (props) => {
          return (
            <span>
              {" "}
              {props.original &&
                moment(props.original.created_date).format(
                  "DD MMM YYYY, h:mm a"
                )}
            </span>
          ); //"DD MMM YYYY, h:mm a"
        },
      },
      {
        width: 150,
        Header: "Ticket Type",
        accessor: "ticket_type",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              <span>
                {props.original.ticket_type == "NORMAL"
                  ? "Normal"
                  : props.original.ticket_type == "STUDENT"
                  ? "Student"
                  : props.original.ticket_type == "EARLY_BIRD"
                  ? "Early bird"
                  : props.original.ticket_type == "GROUP"
                  ? "Group"
                  : props.original.ticket_type == "VIP"
                  ? "Vip"
                  : props.original.ticket_type}{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Actions",
        Cell: (props) => {
          return (
            <div className="actions-center">
              <Button
                color="primary"
                variant="contained"
                size="small"
                className={classes.button}
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.history.push(
                    "/admin/managewebinar/registrationDetails",
                    {
                      webinar: props.original,
                    }
                  );
                }}
              >
                View
              </Button>
            </div>
          );
        },
      },
    ];
    return column;
  };
  getNormalBookingColumn = () => {
    const { classes } = this.props;
    // const theme = createMuiTheme({
    //   palette: {
    //     primary: green
    //   }
    // });
    let column = [
      {
        width: 120,
        Header: "User Type",
        accessor: "user_type",
        Cell: (props) => {
          return (
            <span>
              {props.original.user_type == "NORMAL"
                ? "Normal"
                : props.original.user_type == "STUDENT"
                ? "Student"
                : props.original.user_type == "GOVERNMENT"
                ? "Government"
                : props.original.user_type}
            </span>
          );
        },
      },
      {
        width: 150,
        Header: "Ticket Type",
        accessor: "ticket_type",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              {" "}
              <span>
                {props.original.ticket_type == "NORMAL"
                  ? "Normal"
                  : props.original.ticket_type == "STUDENT"
                  ? "Student"
                  : props.original.ticket_type == "EARLY_BIRD"
                  ? "Early bird"
                  : props.original.ticket_type == "GROUP"
                  ? "Group"
                  : props.original.ticket_type}{" "}
              </span>
            </div>
          );
        },
      },
      {
        width: 150,
        Header: "Name",
        Cell: ({ original }) => {
          const { first_name, last_name } = original;
          const fullName =
            first_name && last_name
              ? `${first_name} ${last_name}`
              : first_name
              ? first_name
              : "N/A";
          return (
            <span>{first_name === last_name ? first_name : fullName}</span>
          );
        },
      },
      {
        width: 250,
        Header: "Organization Id",
        accessor: "org",
      },
      {
        width: 150,
        Header: "Booking Id",
        accessor: "main_booking_id",
      },
      {
        width: 220,
        Header: "Booking Date and Time",
        Cell: (props) => {
          return (
            <span>
              {" "}
              {props.original &&
                moment(props.original.created_date).format(
                  "DD MMM YYYY, h:mm a"
                )}
            </span>
          ); //"DD MMM YYYY, h:mm a"
        },
      },
      {
        width: 170,
        Header: "Booking Status",
        accessor: "booking_status",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              {" "}
              <span>
                {props.original.booking_status == "WAITING"
                  ? "Waiting"
                  : props.original.booking_status == "CONFIRMED"
                  ? "Confirmed"
                  : props.original.booking_status}
              </span>
            </div>
          );
        },
      },
      {
        width: 170,
        Header: "Payment Status",
        accessor: "payment_status",
        Cell: (props) => {
          // console.log(")()()()()",props.original.ticket_status , props.original.payment_status)

          return (
            <div>
              {props.original.ticket_status === "APPROVED" &&
              props.original.payment_mode === "offline" &&
              props.original.payment_status === "PENDING" &&
              props.original.booking_status != "CANCELED" ? (
                <div className="actions-center">
                  {/* <Tooltip title="Accept" disableFocusListener>
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={
                    ()=>{
                      this.setState({
                        showPaymentModel:true,
                        booking_id:props.original.uuid,
                        ticket_type:props.original.ticket_type,
                        paymentTitle:"Have You Recieved Complete Amount for this webinar Booking ?"
                      })
                    }
                    //()=>this.updatePaymentStatus(props.original.uuid,props.original.ticket_type)
                  }
                >
                  <Icon>check</Icon>
                </IconButton>
              </Tooltip> */}

                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                      this.setState({
                        showPaymentModel: true,
                        booking_id: props.original.uuid,
                        amount: props.original.amount,
                        ticket_type: props.original.ticket_type,
                        paymentTitle: `Have You Recieved $${props.original.amount} for this webinar Booking ?`,
                      });
                    }}
                  >
                    Payment received
                  </Button>

                  {/* <Tooltip title="Reject">
                <IconButton
                  color="primary"
                  className={classes.button}
                  // onClick={e => {
                  //   e.stopPropagation();
                  //   this.setState({
                  //     seatsToBeChanged: webinar.original,
                  //     seatsToBeChangedValue: false,
                  //     showAcceptModal: true,
                  //     popText: "Are you want to cancel this seat?"
                  //   })

                  // }}
                >
                  <Icon>clear</Icon>
                </IconButton>
              </Tooltip> */}
                </div>
              ) : // <div>
              //   {
              props.original.ticket_status == "APPROVED" &&
                props.original.payment_status === "PENDING" &&
                props.original.booking_status === "CANCELED" ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={true}
                  onClick={() => {
                    this.setState({
                      showPaymentModel: true,
                      booking_id: props.original.uuid,
                      amount: props.original.amount,
                      ticket_type: props.original.ticket_type,
                      paymentTitle: `Have You Recieveddd $${props.original.amount} for this webinar Booking ?`,
                    });
                  }}
                >
                  Payment received
                </Button>
              ) : (
                // }
                // </div>
                <div>
                  {props.original.ticket_status == "APPROVED" &&
                  props.original.payment_status === "SUCCESSFUL" ? (
                    <div style={{ marginLeft: "20%" }}>
                      <span>Paid</span>
                    </div>
                  ) : (
                    <div>
                      {props.original.ticket_status == "CANCELED" &&
                      props.original.payment_status === "SUCCESSFUL" ? (
                        <span>
                          {props.original.payment_status}
                          {
                            <div className="actions-center">
                              {/* <Tooltip title="Accept" disableFocusListener>
                      <IconButton
                        color="primary"
                        className={classes.button}
                        onClick={
                          ()=>{
                            this.setState({
                              showPaymentModel:true,
                              booking_id:props.original.uuid,
                              ticket_type:props.original.ticket_type,
                              paymentTitle:"Are you Sure you want to initiate refund Amount for this webinar Booking ?"
                            })
                          }
                         // ()=>this.updatePaymentStatus(props.original.uuid,props.original.ticket_type)
                        }
                      >
                        <Icon>check</Icon>
                      </IconButton>
                    </Tooltip> */}

                              <Button
                                color="primary"
                                variant="contained"
                                className={classes.button}
                                size="small"
                                // className={classes.button}
                                onClick={
                                  () => {
                                    this.setState({
                                      showPaymentModel: true,
                                      booking_id: props.original.uuid,
                                      ticket_type: props.original.ticket_type,
                                      paymentTitle:
                                        "Are you Sure you want to initiate refund Amount for this webinar Booking ?",
                                    });
                                  }
                                  // ()=>this.updatePaymentStatus(props.original.uuid,props.original.ticket_type)
                                }
                              >
                                Accept
                              </Button>
                            </div>
                          }
                        </span>
                      ) : (
                        <div style={{ marginLeft: "20%" }}>
                          {" "}
                          <span>
                            {props.original.payment_status === "NOT_REQUIRED"
                              ? "Not Required"
                              : props.original.payment_status == "PENDING"
                              ? "Pending"
                              : props.original.payment_status}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        },
      },
      {
        width: 170,
        Header: "Payment Mode",
        accessor: "payment_mode",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              {" "}
              <span>
                {props &&
                props.original &&
                props.original.payment_mode == "COUPON"
                  ? "Coupon"
                  : props.original.payment_mode == "offline"
                  ? "Offline"
                  : props.original.payment_mode == "CC" ||
                    props.original.payment_mode == "online"
                  ? "Online"
                  : "Not Required"}
              </span>
            </div>
          );
        },
      },
      {
        width: 200,
        Header: "Registration Status",
        accessor: "ticket_status",
        Cell: (props) => {
          return (
            <div>
              {props.original.user_type != "NORMAL" &&
              props.original.ticket_status === "PENDING" ? (
                <div className="actions-center">
                  <Button
                    variant="contained"
                    disabled={
                      props.original.ticket_type === "STUDENT" &&
                      props.original.booking_status === "CANCELED"
                        ? true
                        : false
                    }
                    color="primary"
                    size="small"
                    className={classes.button}
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      this.setState({
                        showVerificationModel: true,
                        booking_id: props.original.uuid,
                        booking_status: "approved",
                        verificationTitle:
                          "Do you want to approved this booking ?",
                      });
                    }}
                  >
                    Accept
                  </Button>

                  <Button
                    variant="outlined"
                    disabled={
                      props.original.ticket_type === "STUDENT" &&
                      props.original.booking_status === "CANCELED"
                        ? true
                        : false
                    }
                    color="primary"
                    size="small"
                    className={classes.button}
                    onClick={
                      () => {
                        this.setState({
                          showVerificationModel: true,
                          booking_id: props.original.uuid,
                          booking_status: "rejected",
                          verificationTitle:
                            "Do You want to reject the Verification of this booking ?",
                        });
                      }
                      // ()=>this.updateBookingStatus(props.original.uuid,"rejected")
                    }
                  >
                    Reject
                  </Button>
                </div>
              ) : (
                <div style={{ marginLeft: "21%" }}>
                  {" "}
                  <span>
                    {props.original.ticket_status == "APPROVED"
                      ? "Approved"
                      : props.original.ticket_status == "PENDING"
                      ? "Pending"
                      : props.original.ticket_status}
                  </span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        width: 150,
        Header: "Ticket Type",
        accessor: "ticket_type",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              {" "}
              <span>
                {props.original.ticket_type == "NORMAL"
                  ? "Normal"
                  : props.original.ticket_type == "STUDENT"
                  ? "Student"
                  : props.original.ticket_type == "EARLY_BIRD"
                  ? "Early bird"
                  : props.original.ticket_type == "GROUP"
                  ? "Group"
                  : props.original.ticket_type}{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => {
          return (
            <div className="actions-center">
              {/* <Tooltip title="View">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    // console.log("87878788")
                    console.log(props.original,'e on click eventdetail web')
                    this.props.history.push("/admin/managewebinar/registrationDetails", {
                      webinar: props.original
                    });
                  }}
                >
                  <Icon>visibility_icon</Icon>
                </IconButton>
              </Tooltip> */}

              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  // console.log("87878788")
                  this.props.history.push(
                    "/admin/managewebinar/registrationDetails",
                    {
                      webinar: props.original,
                    }
                  );
                }}
              >
                View
              </Button>
            </div>
          );
        },
      },
    ];
    return column;
  };

  handleTab = (activeTab = 0) => {
    // console.log('inside handleTab',activeTab)
    this.setState({
      activeTab,
    });
  };

  cancelModalAccept = () => {
    this.setState({
      showAcceptModal: false,
      seatsToBeChangedValue: null,
      seatsToBeChanged: null,
      cancelModalreject: false,
    });
  };

  approveSeats = () => {
    // console.log('inside approve seats')
    let { seatsToBeChangedValue, seatsToBeChanged } = this.state;
    const { webinar } = this.props.location.state;

    this.setState({
      loader: true,
    });
    axios
      .post(
        `zoom/approveRejectWaitingListWebinar?webinar_id=${seatsToBeChanged.id}&registrant_uuid=${seatsToBeChanged.uuid}&accept=${seatsToBeChangedValue}`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (seatsToBeChangedValue) {
            toastr.success("Waiting Registrant approved Successfully!");
            // setTimeout(function () { window.location.reload(); }, 2000);
            setTimeout(() => {
              // window.location.reload()
              this.props.history.push("/admin/managewebinar/webinarlist", {
                redirected_webinar: true,
                webinar,
                redirected_webinar_id: webinar.id,
              });
            }, 1000);
          } else {
            toastr.success("Waiting Registrant cancelled Successfully!");
            // setTimeout(function () { window.location.reload(); }, 1000);
            setTimeout(() => {
              // window.location.reload()
              this.props.history.push("/admin/managewebinar/webinarlist", {
                redirected_webinar: true,
                webinar,
                redirected_webinar_id: webinar.id,
              });
            }, 1000);
          }
          this.setState({
            loading: false,
            showAcceptModal: false,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          toastr.error(error.response.data.message);
          this.setState({
            ...this.state,
            showAcceptModal: false,
            loading: false,
          });
          // setTimeout(()=>{
          //   window.location.reload()
          //   },1000)
        } else {
          this.setState({
            loading: false,
          });
        }
      });
  };

  closeRegistration = () => {
    let { id, close_registration } = this.state;
    if (close_registration) {
      this.setState(
        {
          closePopText: "Are you sure you want to start the Registration?",
        },
        () => {
          this.setState({
            showCloseModal: true,
          });
        }
      );
    } else {
      this.setState(
        {
          closePopText: "Are you sure you want to pause the Registration?",
        },
        () => {
          this.setState({
            showCloseModal: true,
          });
        }
      );
    }
  };

  startStopRegistration = () => {
    let { id, close_registration } = this.state;
    this.setState({
      loader: true,
    });
    let checkClose = close_registration;
    close_registration = !close_registration;
    axios
      .get(
        `zoom/closeWebinarRegistration?webinar_id=${id}&close_registration=${close_registration}`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (checkClose) {
            toastr.success("Webinar Registration Started Successfully!");
          } else {
            toastr.success("Webinar Registration Paused Successfully!");
          }
          setTimeout(() => hist.goBack(), 1000);
        }
      })
      .catch((error) => {
        if (error.response) {
          toastr.error(error.response.data.message);
          this.setState({
            loading: false,
            showCloseModal: false,
          });
        } else {
          this.setState({
            loading: false,
            showCloseModal: false,
          });
        }
      });
  };

  resetData = (type) => {
    
    console.log(type, "type in resetData");

    this.setState(
      {
        ...this.state,
        selected_ticket_type: undefined,
        selected_user_type: undefined,
        user_type: "",
        ticket_type: "",
        user_type_normal: "",
        ticket_type_normal: "",
      },
      () => {
        if (type == "normalUserBooking") {
          this.getNormalBookingData();
        } else if (type == "waitingBooking") {
          this.getWaitingBookingData();
        }
      }
    );
  };

  editEventFunc = (webinar) => {
    this.props.history.push("/admin/managewebinar/registrationDetails", {
      webinar,
    });
  };
  cancelModalClose = () => {
    this.setState({
      showCloseModal: false,
    });
  };

  changeTicketOption = (e) => {
    this.setState(
      {
        selected_ticket_type: e && e,
      },
      () => this.getNormalBookingData()
    );
  };
  changeUserOption = (e) => {
    this.setState(
      {
        selected_user_type: e && e,
      },
      () => this.getNormalBookingData()
    );
  };

  render() {
    const { classes } = this.props;
    const theme = withTheme();
    const {
      activeTab,
      topic,
      amount,
      start_date,
      duration,
      VIPseats,
      normalSeats,
      waitingSeats,
      unapprovedSeats,
      agenda,
      webinar_image,
      webinarType,
      id,
      event_name,
      normalUserBooking,
      loading,
      VIPBooking,
      waitingBooking,
      waitingUser,
      unapprovedBooking,
      showAcceptModal,
      paymentTitle,
      showPaymentModel,
      // created_at,
      // close_registration,
      status,
      showCloseModal,
      textField,
      group_booking_price,
      student_price,
      normal_price,
      early_bird_price,
      expiry_date,
      webinar_type,
      selected_user_type,
      selected_ticket_type,
      verificationTitle,
      showVerificationModel,
      remaining_vip_seats,
      remaining_normal_seats,
      total_seats,
      remaining_waiting_seats,
      ticket_type,
      user_type,
      userTypeList,
      ticketTypeList,
      user_type_normal,
      ticket_type_normal,
      appovedUser,      
    } = this.state;

    console.log(normalUserBooking, "normalUserBooking");
    return (
      <div className="manage-banner">
        <div className={classes.root}>
          {/* <Card className="tabs_event"> */}
          <AppBar position="static" color="default" className="tab-header">
            <Tabs
              className="tabs_main"
              value={activeTab}
              onChange={(event, index) => this.handleTab(index)}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#c8102e",
                  color: "#c8102e",
                },
              }}
              variant="fullWidth"
              centered
            >
              <Tab
                icon={<Icon> view_module </Icon>}
                label="General Details"
                style={{
                  width: "100%",
                }}
              />
              <Tab
                icon={<Icon> view_module </Icon>}
                label=" Normal Seats Bookings"
                style={{
                  width: "100%",
                }}
              />
              <Tab
                icon={<Icon> view_module </Icon>}
                label="VIP Seats Bookings"
                style={{
                  width: "100%",
                }}
              />
              <Tab
                icon={<Icon> view_module </Icon>}
                label="Waiting Seats Bookings"
                style={{
                  width: "100%",
                }}
              />
              {/* <Tab
                  icon={<Icon> view_module </Icon>}
                  label="Manage Request"
                  style={{
                    width: "100%"
                  }}
                /> */}
            </Tabs>
          </AppBar>

          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={activeTab}
            onChangeIndex={this.handleTab}
            className="main_wrapper_tabs"
          >
            <TabContainer dir={theme.direction}>
              <div className="add-category-form">
                <Card
                  className="main_wrapper_tabs"
                  style={{ overflow: "-webkit-paged-x" }}
                >
                  <CardContent>
                    <GridContainer>
                      <div className="close_btn_inner">
                        {status === "BOOKING_STARTED" ||
                        status === "SCHEDULED" ? (
                          <span
                            className="close_btn"
                            onClick={this.closeRegistration}
                          >
                            {textField}
                          </span>
                        ) : (
                          <span className="close_btn disable">{textField}</span>
                        )}
                      </div>
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: id ? true : false,
                          }}
                          autoFocus
                          margin="dense"
                          id="Webinar_id"
                          name="Webinar_id"
                          label="Webinar Id"
                          type="text"
                          fullWidth
                          value={id}
                          disabled={true}
                        />
                      </GridItem>

                      {webinar_type == "Paid" && (
                        <GridItem md={12}>
                          <TextField
                            InputLabelProps={{
                              shrink: webinar_type ? true : false,
                            }}
                            autoFocus
                            margin="dense"
                            id="webinar_type"
                            name="webinar_type"
                            label="Webinar Type"
                            type="text"
                            fullWidth
                            value={webinar_type}
                            disabled={true}
                          />
                        </GridItem>
                      )}
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: topic ? true : false,
                          }}
                          autoFocus
                          margin="dense"
                          id="topic"
                          name="topic"
                          label="Topic"
                          type="text"
                          fullWidth
                          value={topic}
                          disabled={true}
                        />
                      </GridItem>

                      <GridItem
                        md={12}
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        style={{ marginTop: "20px" }}
                      >
                        <legend>Webinar Image</legend>

                        <img
                          className="banner_images_main"
                          src={webinar_image}
                          alt="banner_img"
                        ></img>
                      </GridItem>
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: event_name ? true : false,
                          }}
                          margin="dense"
                          id="event_type"
                          name="event_type"
                          label="Event Type"
                          type="text"
                          fullWidth
                          value={event_name}
                          disabled={true}
                        />
                      </GridItem>
                      {/* <GridItem md={12}>
                          <TextField
                            InputLabelProps={{
                              shrink: created_at ? true : false
                            }}
                            margin="dense"
                            id="created_at"
                            name="created_at"
                            label="Webinar Create Date &amp; Time"
                            type="text"
                            fullWidth
                            value={created_at}
                            disabled={true}
                          />
                        </GridItem> */}
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: start_date ? true : false,
                          }}
                          margin="dense"
                          id="start_time"
                          name="start_time"
                          label="Start Date &amp; Time"
                          type="text"
                          fullWidth
                          value={start_date}
                          disabled={true}
                        />
                      </GridItem>
                      {/* <GridItem md={12}>
                          <legend style={{ fontSize: "1rem" }}>Webinar Type</legend>
                          <Select
                            isMulti
                            name="category"
                            options={categoryList}
                            value={category_name}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isDisabled={true}
                          />
                        </GridItem> */}

                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: duration || duration === 0 ? true : false,
                          }}
                          margin="duration"
                          id="duration"
                          name="duration"
                          label="Duration (Mins)"
                          type="text"
                          fullWidth
                          value={duration}
                          disabled={true}
                        />
                      </GridItem>
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: agenda ? true : false,
                          }}
                          margin="dense"
                          id="agenda"
                          name="agenda"
                          label="Agenda"
                          type="text"
                          fullWidth
                          value={agenda}
                          disabled={true}
                        />
                      </GridItem>

                      {webinar_type == "Paid" && (
                        <Fragment>
                          <GridItem md={12}>
                            <TextField
                              InputLabelProps={{
                                shrink: group_booking_price ? true : false,
                              }}
                              margin="dense"
                              id="group_booking_price"
                              name="group_booking_price"
                              label="Group Booking Price"
                              type="text"
                              fullWidth
                              value={group_booking_price}
                              disabled={true}
                            />
                          </GridItem>

                          <GridItem md={12}>
                            <TextField
                              InputLabelProps={{
                                shrink: student_price ? true : false,
                              }}
                              margin="dense"
                              id="student_price"
                              name="student_price"
                              label="Student Price"
                              type="text"
                              fullWidth
                              value={student_price}
                              disabled={true}
                            />
                          </GridItem>

                          <GridItem md={12}>
                            <TextField
                              InputLabelProps={{
                                shrink: normal_price ? true : false,
                              }}
                              margin="dense"
                              id="normal_price"
                              name="normal_price"
                              label="Normal Price"
                              type="text"
                              fullWidth
                              value={normal_price}
                              disabled={true}
                            />
                          </GridItem>

                          <GridItem md={12}>
                            <TextField
                              InputLabelProps={{
                                shrink: early_bird_price ? true : false,
                              }}
                              margin="dense"
                              id="early_bird_price"
                              name="early_bird_price"
                              label="Early Bird Price"
                              type="text"
                              fullWidth
                              value={early_bird_price}
                              disabled={true}
                            />
                          </GridItem>

                          <GridItem md={12}>
                            <TextField
                              InputLabelProps={{
                                shrink: expiry_date ? true : false,
                              }}
                              margin="dense"
                              id="expiry_date"
                              name="expiry_date"
                              label="Expiry Date"
                              type="text"
                              fullWidth
                              value={expiry_date}
                              disabled={true}
                            />
                          </GridItem>
                        </Fragment>
                      )}
                      {/* <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink: total_seats || total_seats >= 0 ? true : false
                            }}
                            margin="dense"
                            id="normal_seats"
                            name="normal_seats"
                            label="Total Seats"
                            type="text"

                            fullWidth
                            value={total_seats}
                            disabled={true}
                          />
                        </GridItem> */}
                      <GridItem md={6}>
                        <TextField
                          InputLabelProps={{
                            shrink:
                              normalSeats || normalSeats === 0 ? true : false,
                          }}
                          margin="dense"
                          id="normal_seats"
                          name="normal_seats"
                          label="Normal Seats"
                          type="text"
                          fullWidth
                          value={normalSeats}
                          disabled={true}
                        />
                      </GridItem>
                      <GridItem md={6}>
                        <TextField
                          InputLabelProps={{
                            shrink:
                              remaining_normal_seats ||
                              remaining_normal_seats >= 0
                                ? true
                                : false,
                          }}
                          margin="dense"
                          id="normal_seats"
                          name="normal_seats"
                          label="Remaining Normal Seats"
                          type="text"
                          fullWidth
                          value={remaining_normal_seats}
                          disabled={true}
                        />
                      </GridItem>

                      <GridItem md={6}>
                        <TextField
                          InputLabelProps={{
                            shrink: VIPseats || VIPseats === 0 ? true : false,
                          }}
                          margin="dense"
                          id="vip_seats"
                          name="vip_seats"
                          label="VIP Seats"
                          type="text"
                          fullWidth
                          value={VIPseats}
                          disabled={true}
                        />
                      </GridItem>

                      <GridItem md={6}>
                        <TextField
                          InputLabelProps={{
                            shrink:
                              remaining_vip_seats || remaining_vip_seats === 0
                                ? true
                                : false,
                          }}
                          margin="dense"
                          id="remaining_vip_seats"
                          name="remaining_vip_seats"
                          label="Remaining VIP seats"
                          type="text"
                          fullWidth
                          value={remaining_vip_seats}
                          disabled={true}
                        />
                      </GridItem>

                      <GridItem md={6}>
                        <TextField
                          InputLabelProps={{
                            shrink:
                              waitingSeats || waitingSeats === 0 ? true : false,
                          }}
                          margin="dense"
                          id="waiting_seats"
                          name="waiting_seats"
                          label="Waiting Seats"
                          type="text"
                          fullWidth
                          value={waitingSeats}
                          disabled={true}
                        />
                      </GridItem>

                      <GridItem md={6}>
                        <TextField
                          InputLabelProps={{
                            shrink:
                              remaining_waiting_seats ||
                              remaining_waiting_seats === 0
                                ? true
                                : false,
                          }}
                          margin="dense"
                          id="waiting_seats"
                          name="waiting_seats"
                          label="Remaining Waiting Seats"
                          type="text"
                          fullWidth
                          value={remaining_waiting_seats}
                          disabled={true}
                        />
                      </GridItem>
                      <GridItem md={12}>
                        {/* <TextField
                            InputLabelProps={{
                              shrink: unapprovedSeats || unapprovedSeats === 0 ? true : false
                            }}
                            margin="dense"
                            id="unapproved_seats"
                            name="unapproved_seats"
                            label="Unapproved Seats"
                            type="text"

                            fullWidth
                            value={unapprovedSeats}
                            disabled={true}
                          /> */}
                      </GridItem>
                    </GridContainer>
                  </CardContent>
                </Card>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <Card
                className="main_wrapper_tabs"
                style={{ overflow: "-webkit-paged-x" }}
              >
                <CardContent style={{ paddingLeft: "60px" }}>
                  <div style={fiter_style}>
                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <Select
                        autoWidth
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        // defaultValue={userTypeList[0]}
                        value={user_type_normal ? user_type_normal : ""}
                        options={userTypeList}
                        onChange={(selectedOption) => {
                          console.log(selectedOption, "selectedOption");
                          this.setState(
                            {
                              normalUserBooking: appovedUser,                              
                              user_type_normal: selectedOption,
                            },
                            () => {
                              
                              let newbookingDetails = this.state.normalUserBooking.filter(
                                (item) =>
                                  item.user_type
                                    .toLowerCase()
                                    .replace("_", " ")
                                    .includes(
                                      selectedOption.value.toLowerCase()
                                    )
                              );
                              this.setState({
                                ...this.state,
                                normalUserBooking: newbookingDetails,
                              });
                              
                            }
                          );
                        }}
                      ></Select>
                    </FormControl>

                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <Select
                        autoWidth
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        value={ticket_type_normal ? ticket_type_normal : ""}
                        options={ticketTypeList}
                        defaultValue = { ticketTypeList[0]}
                        onChange={(selectedOption) => {
                          // let { value } = event.target;
                          debugger;
                          this.setState(
                            {
                              ...this.state,
                              normalUserBooking: appovedUser,
                              ticket_type_normal: selectedOption,
                            },
                            () => {
                              const newbookingDetails = this.state.normalUserBooking.filter(
                                (item) =>
                                  item.ticket_type
                                    .toLowerCase()
                                    // .replace("_", " ")
                                    .includes(
                                      selectedOption.value.toLowerCase()
                                    )
                              );
                              this.setState({
                                normalUserBooking: newbookingDetails,
                              });
                            }
                          );
                        }}
                      ></Select>
                    </FormControl>
                    <ClearButton
                      onClick={() => {
                        this.resetData("normalUserBooking");
                      }}
                      variant="contained"
                      color="iseas"
                    >
                      Clear Filter
                    </ClearButton>

                  </div>

                  <ReactTable
                    data={normalUserBooking || []}
                    // loading={loading}
                    columns={this.getNormalBookingColumn()}
                    defaultPageSize={10}
                    //pageSizeOptions={[25, 50, 100]}
                    loading={normalUserBooking ? false : true}
                    showPaginationBottom={true}
                    minRows={0}
                    noDataText="No Normal Booking found!"
                    getTheadThProps={(state, rowInfo, column, instance) => {
                      return {
                        style: {
                          marginBottom: "13px",
                        },
                      };
                    }}
                  />
                </CardContent>
              </Card>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <Card
                className="main_wrapper_tabs"
                style={{ overflow: "-webkit-paged-x" }}
              >
                <CardContent style={{ paddingLeft: "60px" }}>
                  <ReactTable
                    data={VIPBooking || []}
                    // loading={loading}
                    columns={this.getVIPBookingColumn()}
                    defaultPageSize={10}
                    //pageSizeOptions={[25, 50, 100]}
                    loading={VIPBooking ? false : true}
                    showPaginationBottom={true}
                    minRows={0}
                    noDataText="No VIP Booking found!"
                    getTheadThProps={(state, rowInfo, column, instance) => {
                      return {
                        style: {
                          marginBottom: "13px",
                        },
                      };
                    }}
                  />
                </CardContent>
              </Card>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <Card
                className="main_wrapper_tabs"
                style={{ overflow: "-webkit-paged-x" }}
              >
                <CardContent style={{ paddingLeft: "60px" }}>
                  <div style={fiter_style}>
                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <Select
                        autoWidth
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        value={user_type ? user_type : ""}
                        defaultValue = { userTypeList[0]}
                        options={userTypeList}
                        onChange={(selectedOption) => {
                          console.log(selectedOption, "selectedOption");
                          this.setState(
                            {
                              ...this.state,
                              waitingBooking: waitingUser,
                              user_type: selectedOption,
                            },
                            () => {
                              const newbookingDetails = this.state.waitingBooking.filter(
                                (item) =>
                                  item.user_type
                                    .toLowerCase()
                                    .replace("_", " ")
                                    .includes(
                                      selectedOption.value.toLowerCase()
                                    )
                              );
                              this.setState({
                                waitingBooking: newbookingDetails,
                              });
                            }
                          );
                        }}
                      ></Select>
                    </FormControl>

                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <Select
                        autoWidth
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        // defaultValue = { ticketTypeList[0]}
                        value = { ticket_type ? ticket_type : ""}
                        options={ticketTypeList}
                        onChange={(selectedOption) => {
                          debugger;
                          this.setState(
                            {
                              ...this.state,
                              waitingBooking: waitingUser,
                              ticket_type: selectedOption,
                            },
                            () => {
                              const newbookingDetails = this.state.waitingBooking.filter(
                                (item) =>
                                  item.ticket_type
                                    .toLowerCase()
                                    // .replace("_", " ")
                                    .includes(
                                      selectedOption.value.toLowerCase()
                                    )
                              );
                              this.setState({
                                waitingBooking: newbookingDetails,
                              });
                            }
                          );
                        }}
                      ></Select>
                    </FormControl>
                    <ClearButton
                      onClick={() => {
                        this.resetData("waitingBooking");
                      }}
                      variant="contained"
                      color="iseas"
                    >
                      Clear Filter
                    </ClearButton>
                  </div>
                  <ReactTable
                    data={waitingBooking || []}
                    // loading={loading}
                    columns={this.getWaitingBookingColumn()}
                    defaultPageSize={10}
                    //pageSizeOptions={[25, 50, 100]}
                    loading={waitingBooking ? false : true}
                    showPaginationBottom={true}
                    minRows={0}
                    noDataText="No Waiting Booking found!"
                    getTheadThProps={(state, rowInfo, column, instance) => {
                      return {
                        style: {
                          marginBottom: "13px",
                        },
                      };
                    }}
                  />
                </CardContent>
              </Card>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <ReactTable
                data={unapprovedBooking || []}
                loading={loading}
                columns={this.getUnApprovedBookingColumn()}
                defaultPageSize={10}
                // pageSizeOptions={[25, 50, 100]}
                showPaginationBottom={true}
                minRows={0}
                noDataText="No Unapproved Booking found!"
                getTheadThProps={(state, rowInfo, column, instance) => {
                  return {
                    style: {
                      marginBottom: "13px",
                    },
                  };
                }}
              />
            </TabContainer>
          </SwipeableViews>
          {/* </Card> */}
          <DeleteModel
            title={paymentTitle}
            showModel={showPaymentModel}
            onCancel={() => {
              this.setState({
                showPaymentModel: false,
              });
            }}
            onOk={() => {
              this.updatePaymentStatus();
              this.setState({
                showPaymentModel: false,
              });
            }}
          />
          <DeleteModel
            title={verificationTitle}
            showModel={showVerificationModel}
            onCancel={() => {
              this.setState({
                showVerificationModel: false,
              });
            }}
            onOk={() => {
              this.updateBookingStatus();
              this.setState({
                showVerificationModel: false,
              });
            }}
          />

          <DeleteModel
            showModel={showAcceptModal}
            title={this.state.popText}
            onCancel={this.cancelModalAccept}
            onOk={() => {
              // console.log('ok clicked in deletemodel 1')
              let { seatsToBeChangedValue, seatsToBeChanged } = this.state;
              this.approveSeats(seatsToBeChanged, seatsToBeChangedValue);
            }}
          />
          <DeleteModel
            showModel={showCloseModal}
            title={this.state.closePopText}
            onCancel={this.cancelModalClose}
            onOk={this.startStopRegistration}
          />

          {loading && (
            <div className="loader_icon">
              <img src={loaderIcon} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bookings: state.bookings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleGetEventBookings: (eventId) =>
      dispatch(getEventBookings$.trigger(eventId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(extendedTablesStyle)(EventDetail));



// WEBPACK FOOTER //
// ./src/views/ISEAS/WebinarManagement/EventDetail.js